import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import {
  getFormData,
  getQueryString,
  objectKeysCamelToSnakeCase,
  objectKeysSnakeCaseToCamelCase,
} from 'coreOld/utils';
import { IPreviewPart } from 'partsOld/types';

export const importPartsList = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/list/parts?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return mapRecordsFromServer<any>(data.data, data.recordsActiveAll);
};

export const importPartsSaveBulk = async (data) => {
  return partfinitiClient.post(
    '/import/parts/save-bulk',
    getFormData(objectKeysCamelToSnakeCase(data))
  );
};

export const importPreviewColumns = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/parts/columns?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return mapRecordsFromServer<string>(data.columns);
};

export const importRows = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/parts/list?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return mapRecordsFromServer<Partial<IPreviewPart>>(data.data, data.recordsFiltered);
};

export const importCreate = async (data) => {
  const dataToSend = getFormData(data);

  const { data: record } = await partfinitiClient.post(`/corporate_v2/import/create`, dataToSend);

  return objectKeysSnakeCaseToCamelCase(record);
};

export const importPreview = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/preview/rows?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return mapRecordsFromServer<any>(data.data, data.recordsFiltered);
};

export const columnNameAliases = async (data) => {
  return partfinitiClient.post(
    '/import/column-name/save-column-aliases',
    getFormData(objectKeysCamelToSnakeCase(data))
  );
};

export const previewSaveParts = async (data) => {
  return partfinitiClient.post(
    '/import/preview/save-parts',
    getFormData(objectKeysCamelToSnakeCase(data))
  );
};

export const previewSavePartsStatus = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/preview/save-parts-status?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return data;
};

export const importValidateManufacturers = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/validate/manufacturers?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return data;
};

export const importValidateParts = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/validate/parts?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return data;
};

export const importSaveManufacturers = async (data) => {
  const { part_import } = objectKeysCamelToSnakeCase(data);

  return partfinitiClient.post(
    '/import/parts/save-manufacturers',
    getFormData({ part_import, ...data })
  );
};

export const importParts = async (data) => {
  return partfinitiClient.post(
    '/import/import/start',
    getFormData(objectKeysCamelToSnakeCase(data))
  );
};

export const importPartsStatus = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/import/import/status?${getQueryString(objectKeysCamelToSnakeCase(queryParams))}`
  );

  return data;
};

export const importUomConversions = async (dataToSend) => {
  const { data } = await partfinitiClient.post(
    '/corporate_v2/import/uom-conversions',
    getFormData(dataToSend)
  );

  return data.cli_job;
};
